import { polishPlural } from 'utils'
import copy from 'copy.json'

export const required = (value: string | boolean, message = copy.validators.required) => {
  if (
    value === '' ||
    value === false ||
    String(value).trim() === '' ||
    !String(value).replace(/\s/g, '').length
  )
    return message
}

export const isNumeric = (value: string, message = copy.validators.is_numeric) => {
  if (!/^\d+$/.test(value)) return message
}

export const exactLength = (
  value: string,
  length: number,
  message = `${copy.validators.exact_length} ${length} ${polishPlural(length, 'znaku', 'znaków')}`
) => {
  if (value.length !== length) return message
}

export const minLength = (
  value: string,
  min: number,
  message = `${copy.validators.min_length} ${min} ${polishPlural(min, 'znak', 'znaki', 'znaków')}`
) => {
  if (value.length < min) return message
}

export const maxLength = (
  value: string,
  maxLength: number,
  message = copy.validators.max_length
) => {
  if (value.length > maxLength) return message
}

export const validEmail = (value: string, message = copy.validators.contact_email) => {
  value = value.replace(/[\s]/gi, '')

  if (!/^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/.test(value))
    return message
}

export const validPolishAlphanumericField = (
  value: string,
  message = copy.validators.polish_alphanumeric_field
) => {
  if (!/^([A-Za-z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ "',.-]*)$/.test(value)) return message
}

export const validAlphanumericField = (
  value: string,
  message = copy.validators.alphanumeric_field
) => {
  if (!/^([A-Za-z0-9/.: -]*)$/.test(value)) return message
}

export const validTaxIdentifier = (value: string, message = copy.validators.tax_identifier) => {
  value = value.replace(/[\s-]/gi, '')

  if (value.length !== 10) return copy.validators.tax_identifier_length

  let sum = 0
  const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7]
  const controlNumber = parseInt(value.substring(9, 10))
  const weightCount = weight.length
  for (let i = 0; i < weightCount; i++) {
    sum += parseInt(value.substring(i, i + 1)) * weight[i]
  }

  return !(sum % 11 === controlNumber) ? message : undefined
}

export const validZipCode = (value: string, message = copy.validators.location_zip_code) => {
  value = value.replace(/[\s-]/gi, '')

  if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)) return message
}

export const validEnergyTariffGroup = (
  value: string,
  message = copy.validators.energy_tariff_group
) => {
  if (!/^[A-Z][0-9]{2}[a-z]{0,3}$/.test(value)) return message
}

export const validDate = (value: string, message = copy.validators.date) => {
  if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(value)) return message
}

export const maxTwoDecimals = (value: string, message = copy.validators.max_two_decimals) => {
  if (value.indexOf('.') !== -1) {
    const parts = value.split('.')
    if (parts[1].length > 2) return message
  }
}

export const futureDate = (value: string, message = copy.validators.future_date) => {
  const date = new Date(value)
  const now = new Date()
  if (date < now) return message
}

export const maxDate = (
  value: string,
  max: string,
  message = `${copy.validators.max_date} ${max}`
) => {
  const date = new Date(value)
  const maxDate = new Date(max)
  if (date > maxDate) return message
}

export const minDate = (
  value: string,
  min: string,
  message = `${copy.validators.min_date} ${min}`
) => {
  const date = new Date(value)
  const minDate = new Date(min)
  if (date < minDate) return message
}

export const validContractLength = (value: string, message = copy.validators.contract_length) => {
  if (parseFloat(value) < 1) return message
}

export const minValue = (
  value: string,
  min: number,
  message = `${copy.validators.min_value} ${min}`
) => {
  if (parseFloat(value) < min) return message
}

export const minValueExcluding = (
  value: string,
  min: number,
  message = `${copy.validators.min_value_excluding} ${min}`
) => {
  if (parseFloat(value) <= min) return message
}

export const maxValue = (
  value: string,
  max: number,
  message = `${copy.validators.max_value} ${max}`
) => {
  if (parseFloat(value) > max) return message
}

export const minSearchLength = (
  value: string,
  minLength: number,
  message = copy.validators.min_search_length
) => {
  if (value !== '' && value.length < minLength) return message
}

export const noDecimals = (value: string, message = copy.validators.no_decimals) => {
  if (value.indexOf('.') !== -1 || value.indexOf(',') !== -1) return message
}

export const includesNoNumbers = (value: string, message = copy.validators.includes_no_numbers) => {
  if (/[0-9]/.test(value)) return message
}

export const validFileExtensions = [
  '.numbers',
  '.xls',
  '.xlsx',
  '.xlsm',
  '.xlt',
  '.xltx',
  '.xltm',
  '.xml',
  '.ods',
  '.csv',
  '.tsv',
  '.tab'
]

export const validFileExtension = (value: string, message = copy.validators.file_extension) => {
  const fileName = value.toLowerCase()
  const fileExtension = fileName.substring(fileName.lastIndexOf('.'))

  if (!validFileExtensions.includes(fileExtension)) return message
}

export const noPolishLetters = (value: string, message = copy.validators.no_polish_letters) => {
  if (/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/.test(value)) return message
}

export const validAzimuth = (value: number, message = copy.validators.azimuth) => {
  if (value < -180 || value > 180) return message
}
